import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import update from 'immutability-helper';

import GET_PARTICIPANT_LIST_QUERY from 'coaching/queries/GetParticipantList.gql';
import {
  GetParticipantList,
  GetParticipantList_coaching_getParticipantList_participants,
} from 'coaching/queries/__generated__/GetParticipantList';

export type Props = {
  children: (props: {
    participants?: GetParticipantList_coaching_getParticipantList_participants[];
    loading: boolean;
    error?: ApolloError;
    onNextPage: (after?: string | null) => Promise<void>;
    endCursor?: string | null;
    hasNextPage?: boolean;
  }) => React.ReactNode;
};

export default function GetParticipantsContainer(props: Props) {
  return (
    <Query<GetParticipantList> query={GET_PARTICIPANT_LIST_QUERY}>
      {({ loading, error, data, fetchMore }) => {
        const handleNextPage = async (after?: string | null) => {
          await fetchMore({
            variables: {
              after,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) {
                return previousResult;
              }

              const existingParticipants =
                previousResult.coaching?.getParticipantList?.participants ?? [];
              const newParticipants =
                fetchMoreResult.coaching?.getParticipantList?.participants ?? [];

              return update(previousResult, {
                coaching: {
                  getParticipantList: {
                    pageInfo: {
                      $set: fetchMoreResult.coaching?.getParticipantList.pageInfo,
                    },
                    participants: { $set: [...existingParticipants, ...newParticipants] },
                  },
                },
              });
            },
          });
        };

        return props.children({
          participants: data?.coaching?.getParticipantList?.participants,
          endCursor: data?.coaching?.getParticipantList?.pageInfo?.endCursor,
          hasNextPage: data?.coaching?.getParticipantList?.pageInfo?.hasNextPage,
          loading,
          error,
          onNextPage: handleNextPage,
        });
      }}
    </Query>
  );
}
